import CustomizableAvatar from "../common/CustomizableAvatar";
import Smartlend from "../../assets/SMARTLEND.png";
import CustomButton from "../common/CustomButton";
import { Link } from "react-router-dom";

const PasswordResetNotification = () => {
  return (
    <div className=" container mx-auto my-10  text-center  p-8 ">
      <CustomizableAvatar
        src={Smartlend}
        customClass={"flex justify-center py-4"}
      />
      <p className=" text-4xl font-medium p-7">Reset password</p>
      <p className="text-sm font-normal px-8 pb-2 text-center">
        We just sent a password reset link to{" "}
        <span className="text-amber-300">idowu@stutern.com</span>. Click on the
        link to complete password reset
      </p>
      <p className="text-amber-700 text-base p-3 pb-8">
        Please note that the link will expire in 4 hours
      </p>
      <CustomButton
        className={
          "bg-indigo-500 text-slate-50 border rounded my-3 cursor-pointer hover:bg-indigo-600"
        }
      >
        <Link to={"/resetPassword"} className="px-14">
          Open email
        </Link>
      </CustomButton>
      <p className="py-5">
        {" "}
        Didn't get the email?{" "}
        <Link to={"#request email"} className="text-indigo-500">
          {" "}
          Request again
        </Link>
      </p>
    </div>
  );
};

export default PasswordResetNotification;
